import { RouterEffects } from '../router/router.effects';

export const appEffects = [RouterEffects];
